import { useCallback, useEffect, useState } from 'react'
import { useT } from '../../../../../../helpers/i18n';
import { useDispatch, useSelector } from 'react-redux'
import { fetchBedroomPricesAction, fetchPropertiesPricesAction,  fetchPropertiesWithChainAction,  fetchSinglePropertyData, setLoadingProperties, setSearchSpinner } from '../../../../../../redux/actions'
import BedroomsView from './BedroomsView'
import Thumbs from '../../../../properties/partials/Thumbs'
import Gallery from '../../../../properties/panel/Gallery'
import PanelBody from '../../../../properties/panel/PanelBody'
import Checkers from '../../../../../../helpers/class/Checkers'
import BookingSearchBar from '../../../../index/BookingSearchBar'
import BookingBedroomButtons from './BookingBedroomButtons'
import { fetchBuilderSettingByKey } from '../../../../../../helpers/MethodHelper'
import Skeleton from 'react-loading-skeleton'

export default function ChainPropertyData(props) {
  const t = useT();

    const dispatch = useDispatch()

    const singlePropertyData = useSelector(state => state['singlePropertyData']['propertyData'])

    const chainId = singlePropertyData && singlePropertyData.chain_id ? singlePropertyData.chain_id : null

    const isHotel = useSelector(state => state['appSettings']['isHotel'])

    const [initialFetch, setInitialFetch] = useState(false)

    const propertiesWithChain = useSelector(state => state['propertieswithChainData']['propertiesWithChain'])

    const propertyId = useSelector(state => Checkers.isValidPositiveNumber(state['propertiesParams']['property_id']) ?
        state['propertiesParams']['property_id']
        : (state['propertiesParams']['property_id']).substring(0, (state['propertiesParams']['property_id']).indexOf("?")));

    const [infoWindowState, setInfoWindowState] = useState(null);

    const updateInfoWindowState = useCallback(function (state) {

        setInfoWindowState(() => state);
    }, []);

    let centerObj = {};

    let property_id = 0;

    const prices = useSelector(state => state['appSettings']['propertiesPricing'])

    const checkin = useSelector(state => state['propertiesParams']['checkin'])

    const checkout = useSelector(state => state['propertiesParams']['checkout'])

    const pageId = useSelector(state => state['propertiesParams']['page_id'])

    const adults = useSelector(state => state['propertiesParams']['adults'])

    const kids = useSelector(state => state['propertiesParams']['kids'] + state['propertiesParams']['infants'])

    const triggerSearh = useSelector(state => state['appSettings']['searchTrigger'])

    useEffect(() => {
        if (Checkers.isValidPositiveNumber(chainId)) {
            dispatch<any>(fetchPropertiesWithChainAction(chainId))
        }
    }, [chainId])

    const fetchData = async () => {
        await dispatch<any>(
            fetchPropertiesPricesAction(
                propertiesWithChain,
                pageId,
                checkin,
                checkout,
                adults,
                kids,
                true,
                1
            )
        );
        dispatch(setSearchSpinner(false));
    }

    const initialFetchHandler = async () => {
        if (!initialFetch && propertiesWithChain != undefined) {
            await fetchData();
            setInitialFetch(true)
        }
    }

    useEffect(() => {
        fetchData();
      }, [triggerSearh]);

    useEffect(() => {
        if (!initialFetch && propertiesWithChain!=undefined) {
            initialFetchHandler()
        }
      }, [propertiesWithChain]);


    const [previousProperty, setPreviousProperty] = useState(property_id);

    const [relocatedCenter, setRelocatedCenter] = useState(centerObj);

    const changeMarker = useCallback((lat, lng, property_id) => {
        // eslint-disable-next-line react-hooks/exhaustive-deps
        centerObj = {};
        if (Checkers.isValidNumber(lat) && Checkers.isValidNumber(lng)) {
            // eslint-disable-next-line react-hooks/exhaustive-deps
            centerObj = { lat: parseFloat(lat), lng: parseFloat(lng) };
        }
        const thisChild = document.getElementById('property_marker_' + property_id);
        const prevChild = document.getElementById('property_marker_' + previousProperty);
        if (thisChild) {
            thisChild.parentElement.style.zIndex = '1';
        }
        if (prevChild) {
            prevChild.parentElement.style.zIndex = '0';
        }
        setRelocatedCenter(() => centerObj);
        setPreviousProperty(property_id);
    }, [relocatedCenter, previousProperty]);


    const changeMarkerOnHover = (lat, lng, property_id) => {
        if (infoWindowState == null) {
            changeMarker(lat, lng, property_id);
        }
    }

    useEffect(() => {
        dispatch<any>(fetchSinglePropertyData(propertyId))
    }, [])

    return (
        <>
            {
                props.isChain && propertiesWithChain?
                    <>
                     <p className="block-title m-t-40 hint-text no-margin justify-content-left text-left d-block ">{t('property.groupIntro')}</p>
                     <h2 className="pb-4 mt-1 fw-normal">{t('property.groupOfProperties')}</h2>
                        <div
                            id="booking-search-bar"
                            className="SearchBar-Form__column row justify-content-end bg-white no-margin p-2 w-100 d-flex border-radius-10 shadow position-relative" >
                            <BookingSearchBar
                                containerClass={"container-fluid"}
                                padding={10}
                                isManager={true}
                                noShadow={true}
                                sliderSearchBar={true}
                                sliderSearchBarFullWidth={false}
                                isNotForList = {true}
                                //  searchbarThemeColor={app.searchbarThemeColor}
                                //  rgbaDesignColor={props.rgbaDesignColor}
                                //  searchbarRadius={props.searchbarRadius}
                                //  searchbarShadow={props.searchbarShadow}
                                // bookingSearchbarWithBedrooms={props.bookingBedrooms}
                                isHomePage={false}
                                isHotel={true}
                            />
                        </div>
                    </>
                    : 
                    <>
                    {!isHotel ? <div>
                        <Skeleton height={75} className="col-12 b-rad-lg d-block" />
                    </div> : <></>} 
                    </>
            }
            <div className="pt-10 mt-4">
                <div className="row">
                    {propertiesWithChain ?
                        propertiesWithChain.properties.map((b) => {
                            const propertyPrice = prices?.find((p) => p.propertyId === b.property_id)?.price || 0;
                            return (
                                <div className="col-4 col-md-4 pb-4" key={b.property_id.toString()}>
                                    <Thumbs
                                        property_id={b.property_id}
                                        property_title={b.property_title}
                                        property_moto={b.moto}
                                        images={b.featured_images}
                                        captions={b.captions}
                                        changeMarkerOnHover={changeMarkerOnHover}
                                        updateInfoWindowState={updateInfoWindowState}
                                        // sourcePath={b.sourcePath}
                                        minimumPrice={propertyPrice}
                                        average_price={b.average_price}
                                        capacity={b.capacity}
                                        bedrooms={b.bedrooms}
                                        hidePrices={b.hide_prices}
                                        hasOpenCalendar={b.has_open_calendar}
                                        inquiriesActive={b.inquiries_active}
                                        tags={b.tags}
                                        system_type_id={b.system_type_id}
                                        classification={b.classification}
                                        propertyType={b.type}
                                        isHotel={false}
                                        isChain={props.isChain}
                                        isNotForList={true}
                                    />
                                </div>
                            )
                        })
                        : 
                        <>
                        {!isHotel ? <div>
                            <Skeleton height={340} className="col-12 b-rad-lg d-block" />
                            <Skeleton height={27} className="col-12 b-rad-lg d-block" />
                            <Skeleton height={27} className="col-12 b-rad-lg d-block" />
                        </div> : <></>}
                        </>
                        }
                </div>
            </div>
        </>
    );
}